import {Directive, ElementRef, EventEmitter, forwardRef, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {SetOptions} from 'eonasdan-bootstrap-datetimepicker';
import * as $ from 'jquery';
import * as _ from 'lodash';
import * as moment from 'moment';
import {Observable} from 'rxjs';
@Directive({
  // tslint:disable:directive-selector
  selector: '[dateTimePicker]',
  // tslint:enable:directive-selector
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => DateTimePickerDirective), multi: true }]
})
/*tslint:disable*/
export class DateTimePickerDirective implements OnInit, OnChanges, OnDestroy, ControlValueAccessor {
  @Input() dateTimePicker: SetOptions;
  @Input() minDate: moment.Moment|Date|string|false;
  @Input() maxDate: moment.Moment|Date|string|false;
  @Input() disabledDates: (moment.Moment|Date|string)[];
  @Input() enabledFirstDaysOfMonth: boolean;
  @Input() enabledLastDaysOfMonth: boolean;
  @Input() daysOfWeekDisabled: boolean;
  @Input() markDisabled: Observable<boolean>;
  @Output() firstDateValue = new EventEmitter<string>();

  _date: moment.Moment|Date|string|null = null;
  private dpElement: any;
  private onChange: any;
  private onTouched: any;

  constructor(el: ElementRef) {
    const $parent = $(el.nativeElement.parentElement);
    this.dpElement = $parent.hasClass('input-group') ? $parent : $(el.nativeElement);
  }

  ngOnInit(): void {
    this.dpElement.datetimepicker(this.dateTimePicker);
    this.dpElement.data('DateTimePicker').date('2019-12-12');
      if (this.enabledFirstDaysOfMonth) {
        this.dpElement.data('DateTimePicker').enabledDates(this.getEnabledFirstDayOfMonth());

    }
      if (this.enabledLastDaysOfMonth) {
        this.dpElement.data('DateTimePicker').enabledDates(this.getEnabledLastDayOfMonth());

    }
    this.dpElement.on('dp.change', e => {
      if (e.date !== this._date) {
        this._date = moment(e.date).format('YYYY-MM-DD');
        if (this.onChange) {
          this.onChange(moment(e.date).format('YYYY-MM-DD'));
        }
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    const dpe = this.dpElement.data('DateTimePicker');
    if (dpe) {
      if (_.has(changes, 'dateTimePicker')) {
        const options = _.get(changes, 'dateTimePicker.currentValue');
        _.forOwn(options, (value, key) => { dpe[key](value); });
      }

      if (_.has(changes, 'minDate') && changes.minDate.currentValue !== changes.minDate.previousValue) {
        const minDate = _.get(changes, 'minDate.currentValue');
        dpe.minDate(minDate);
      }

      if (_.has(changes, 'maxDate')) {
        const maxDate = _.get(changes, 'maxDate.currentValue');
        dpe.maxDate(maxDate);
      }

      if (_.has(changes, 'disabledDates')) {
        const disabledDates = _.get(changes, 'disabledDates.currentValue');
        dpe.disabledDates(disabledDates);
      }

      if (_.has(changes, 'daysOfWeekDisabled')) {
        const daysOfWeekDisabled = _.get(changes, 'daysOfWeekDisabled.currentValue');
        if (daysOfWeekDisabled) {
          dpe.daysOfWeekDisabled([0, 6]);
        }
      }
      if (_.has(changes, 'markDisabled')) {
        this.markDisabled.subscribe(value => {
          if (value === true) {
            dpe.disable();
          }
        })
      }
    }

  }
  // @ts-ignore
  getEnabledFirstDayOfMonth(){
    var arr = [];
    // 2 years ago
    var start = moment().startOf('month').subtract(2, 'years');
    // In two years
    var end = moment().startOf('month').add(2, 'years');
    while( start.isBefore(end) ){
      arr.push(start.clone());
      start.add(1, 'month');
    }


    return arr;
  }

  // @ts-ignore
  getEnabledLastDayOfMonth(){
    var arr = [];
    // 2 years ago
    var startendOf = moment().endOf('month').subtract(2, 'years');
    // In two years
    var end = moment().startOf('month').add(2, 'years');
    var endendOf = moment().endOf('month').add(2, 'years');



    // @ts-ignore
    while( startendOf.isBefore(end) ){
      arr.push(startendOf.clone());
      if (startendOf.format('MM') === '03'||
        startendOf.format('MM') === '05'||
        startendOf.format('MM') === '10'||
        startendOf.format('MM') === '08'){
        startendOf.add(30, 'days');
      }
      else if (startendOf.format('MM') === '04' ||
        startendOf.format('MM') === '02'||
        startendOf.format('MM') === '09'||
        startendOf.format('MM') === '07'||
        startendOf.format('MM') === '11'||

        startendOf.format('MM') === '12'||
        startendOf.format('MM') === '06'){

        startendOf.add(31, 'days');
      }

      else if (startendOf.format('MM') === '01' &&
        startendOf.format('YYYY') != '2024' &&
        startendOf.format('YYYY') != '2028'&&
        startendOf.format('YYYY') != '2032'){
        startendOf.add(28, 'days');
      } else {
        startendOf.add(29, 'days');
      }

    }
    return arr;
  }

  ngOnDestroy(): void {
    const dpe = this.dpElement.data('DateTimePicker');
    if (dpe) {
      dpe.destroy();
    }
  }

  writeValue(value: any): void {
    const dpe = this.dpElement.data('DateTimePicker');
    if (dpe) {
      this.firstDateValue.emit(this.dpElement[0].value ? this.dpElement[0].value : value);
      dpe.date(value);

    }
  }

  registerOnChange(fn: any): void { this.onChange = fn; }

  registerOnTouched(fn: any): void { this.onTouched = fn; }

  @HostListener('blur')
  onBlur(): void {
    if (this.onTouched) {
      this.onTouched();
    }
  }
}
